module.exports = __webpack_public_path__ + "img/bc478ee.png";